import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  breakpointSizes,
  fluidFontSize,
  fontWeights,
  minBreakpointQuery,
} from '../styles';
import { Button, Tag } from './ui';

const StyledCaseStudyCard = styled.article`
  border-radius: 20px;
  overflow: hidden;
  padding: 30px;
  display: flex;
  flex-direction: column;

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.large`
    padding: 50px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding: 60px;
  `}
`;

const StyledImage = styled.img`
  height: 60px;
  width: 100%;
  max-width: 180px;
`;

const StyledTags = styled.div`
  margin-top: 20px;
  margin-top: 36px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

const StyledHeading = styled.h3`
  margin-top: 20px;
  color: ${brandColours.secondary};
  font-weight: ${fontWeights.semibold};
  ${fluidFontSize(
    '24px',
    '40px',
    breakpointSizes.tiny,
    breakpointSizes.xxxxlarge
  )};
`;

const StyledText = styled.p`
  margin: 20px 0;
  line-height: 1.7;
`;

const StyledButton = styled(Button)`
  margin-top: auto;

  ${minBreakpointQuery.smedium`
    max-width: 225px;
  `}
`;

const CaseStudyCard = caseStudy => {
  const { logo, categories, heading, summary, slug, ...props } = caseStudy;

  return (
    <StyledCaseStudyCard {...props}>
      <StyledImage src={logo.url} alt={logo.alt} loading="lazy" />
      <StyledTags>
        {categories.map(({ name }, id) => (
          <Tag key={id}>{name}</Tag>
        ))}
      </StyledTags>
      <StyledHeading>{heading}</StyledHeading>
      <StyledText>{summary}</StyledText>
      <StyledButton to={caseStudy}>Read case study</StyledButton>
    </StyledCaseStudyCard>
  );
};

export default CaseStudyCard;

export const CaseStudyCardFragment = graphql`
  fragment CaseStudyCardFragment on DatoCmsCaseStudy {
    logo {
      url
      alt
    }
    categories {
      name
    }
    heading: title
    summary
    ...LinkFragment
  }
`;
